import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	noOptions: {
		id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.users-configured.no-options',
		defaultMessage: 'No options',
		description: 'Message informing the user that no options were found.',
	},
	startTyping: {
		id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.users-configured.start-typing',
		defaultMessage: 'Start typing to search for users',
		description: 'Message informing the user to start typing to search for users.',
	},
});
